import {useQuery} from 'react-query';
import {getSuggestionChart} from 'services/myAd/chart/auctionSuggestionChart';

const useGetSuggestionChart = (guid: string) => {
  const {data: AuctionSuggestionData, isLoading: auctionSuggestionChartIloading} =
    useQuery(['auction-suggetion-chart', guid], getSuggestionChart);
  return {AuctionSuggestionData, auctionSuggestionChartIloading};
};

export default useGetSuggestionChart;
